import { Grid } from '@material-ui/core';
import React from 'react';

import { IExtendedPermission } from '~/src/dash/utils/permission_service';
import { H2 } from '~/src/dash/views/component-view';

interface IProps {
  missingPermissions: IExtendedPermission[];
}

interface IPropsErrorPaper {
  err: string;
}

export default class ModelMissingPermission extends React.Component<IProps> {
  render() {
    return (
      <div>
        <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
          <Grid item>
            <H2>Sorry you don't have the permission for this section</H2>
          </Grid>
          <Grid item>Missing permission:</Grid>
          {this.props.missingPermissions.map((perm: IExtendedPermission) => {
            return <Grid item>{perm.description + '  (' + perm.name + ')'}</Grid>;
          })}
        </Grid>
      </div>
    );
  }
}

export class ModelErrorPaper extends React.Component<IPropsErrorPaper> {
  render() {
    return (
      <div style={{ marginLeft: '36px', marginTop: '20px' }}>
        <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
          <Grid item>
            <H2>Error:</H2>
          </Grid>
          <Grid item>{this.props.err.toString()}</Grid>
        </Grid>
      </div>
    );
  }
}
